/**
 * 대시보드 ↔ 쇼츠 에디터 사이의 postMessage 계약.
 *
 * 에디터는 대시보드가 `window.open` 으로 띄우는 별도 서브도메인 앱이라 storage /
 * BroadcastChannel 을 공유할 수 없다. 내보내기를 시작하면 에디터 탭은 opener 에게
 * 이 메시지를 보내고 스스로 닫히며, 대시보드는 '렌더 완료' 탭으로 전환해 렌더 중인
 * 카드를 보여준다. 양쪽이 같은 상수를 쓰도록 계약을 여기 한곳에 둔다.
 */
export const EDITOR_EXPORT_STARTED = 'shorts:export-started';

export type EditorExportStartedMessage = {
  type: typeof EDITOR_EXPORT_STARTED;
  projectId: string;
};

/** 수신 측 가드 — origin 검증과 함께 쓴다 (origin 검증이 실제 보안 경계). */
export function isEditorExportStarted(data: unknown): data is EditorExportStartedMessage {
  if (typeof data !== 'object' || data === null) return false;
  const msg = data as { type?: unknown; projectId?: unknown };
  return msg.type === EDITOR_EXPORT_STARTED && typeof msg.projectId === 'string';
}
